import { h } from "preact"
import { fetchSearchSuggestion } from "Scripts/utils";
import debounce from "debounce";

export const SuggestionItem = ({suggestion, query, setQuery, setSearchSuggestion, setIsFetching}) => {
  const highlightedText = suggestion.replace(new RegExp(query, "gi"), (match) => `<b>${ match }</b>`);
  
  const handleClick = (e) => {
    e.preventDefault();
    location.href = `/search?q=${suggestion}`
  }
  
  const handleOnMouseOver = (e) => {
      setIsFetching(true);
      fetchSearchSuggestion(suggestion).then((response) => {
        const {suggestions, query, ...rest} = response
        console.log('response', response)
        setSearchSuggestion({...rest, isFetching: false});
        setIsFetching(false)
      });
  }
  
  return (
    <li>
      <a href={ suggestion }
         onmouseover={ handleOnMouseOver }
         onclick={ handleClick }
         dangerouslySetInnerHTML={ {__html: highlightedText} }/>
    </li>
  )
}
